import { AlertCircle, CheckCircle2 } from 'lucide-react';
import { IClaimFormStatus } from '../../../../types/claim/form';

type FormStatusProps = {
  state: IClaimFormStatus;
};

export const FormStatus = ({ state }: FormStatusProps) => {
  if (!state.isSuccessful && (!state.message || state.message === '')) {
    return null;
  }

  return (
    <div
      className={`mb-6 p-4 rounded-md flex items-start gap-3 ${
        state.isSuccessful
          ? 'bg-green-50 text-green-700'
          : 'bg-red-50 text-red-700'
      }`}
    >
      {state.isSuccessful ? (
        <CheckCircle2 className="h-5 w-5 mt-0.5" />
      ) : (
        <AlertCircle className="h-5 w-5 mt-0.5" />
      )}
      <p>{state.message}</p>
    </div>
  );
};
